import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from "vue2-google-maps";
import './style.scss';

Vue.config.productionTip = false
Vue.config.publicPath = './'

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCOCbb0AFJisachAIPn4OU-sKUKAUbfvnI",
    libraries: "places" // necessary for places input
  }
});

// new Vue({
//   el: "#app",
//   components: { App },
//   template: "<App/>"
// });

new Vue({
  render: h => h(App),
}).$mount('#app')